import { CLIENTS } from "@/data/content";
import { BrandLogo } from "@/components/BrandLogo";
import { Reveal } from "@/components/Reveal";

export const TrustMarquee = () => {
  const items = [...CLIENTS, ...CLIENTS];
  return (
    <section data-testid="trust-marquee" className="relative py-16 border-y border-stone-200 bg-white overflow-hidden marquee-pause">
      <Reveal className="max-w-[1400px] mx-auto px-6 lg:px-10 mb-10">
        <div className="text-center text-xs uppercase tracking-[0.25em] text-stone-500">
          In us they trust · A few of the organisations we deliver for
        </div>
      </Reveal>

      <div className="relative w-full overflow-hidden">
        <div className="marquee-track flex items-center gap-10 md:gap-14 whitespace-nowrap">
          {items.map((c, i) => (
            <div
              key={`${c.name}-${i}`}
              data-testid={`trust-logo-${i}`}
              className="flex-shrink-0"
            >
              <BrandLogo name={c.name} domain={c.domain} size={32} monochrome />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TrustMarquee;
